import { Loader } from "@googlemaps/js-api-loader";

export default {
  install(Vue, options) {
    Vue.mixin({
      methods: {
        async loadMapsLibrary (library) {
          const loader = new Loader({
            apiKey: options.apiKey,
            version: options.version || 'beta',
            language: 'es'
          });

          return await loader.importLibrary(library)
        }
      }
    })
  }
};